import React, { useContext } from 'react';
import { useStyles } from '../../theme/Auth';
import {InputV2, ButtonV2, Typography, Box, Link, Icon, ICONS_NAME} from '@/elements';
import Logo from '../../components/global/Logo';
import AuthWrapper from '../../components/global/Wrappers/authWrapper';
import { useNavigate } from 'react-router-dom';
import { Controller, useForm } from 'react-hook-form';
import routes from '../../routes';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { AuthContext } from '../../context/auth';
import { useMutation } from '@apollo/client';
import { Login } from '../../actions/update';
import {COLORS} from "@/constants";
import {trimHandler} from "@/utils/trimHandler.js";
import {toast} from "react-toastify";
import {useToggle} from "@hooks";

const Auth = () => {
  const classes = useStyles();
  const navigate = useNavigate();

  const context = useContext(AuthContext);

  const [showPassword, setShowPassword] = useToggle(false);

  const [login, { error, loading }] = useMutation(Login, {
    context: {
      plug: true,
    },
  });

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const onSubmit = (data) => {
    localStorage.removeItem('jwtToken');
    login({
      variables: {
        password: data.password,
        email: data.email,
        type: 'PARTNER_ACCOUNT_EMPLOYEE',
      },
    })
      .then((res) => {
        context.login(res.data.login.accessToken);
        navigate('/accounts');
      })
      .catch((err) => {
        console.log(err.message)
        toast.error(err.message)
      });
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string().required('The field is required').email('Email address must be valid'),
    password: Yup.string().required('The field is required'),
  });

  const {
    handleSubmit,
    formState: { errors },
    control,
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  return (
    <>
      <AuthWrapper>
        <Logo />
        <Box justify="center" margin="0 0 30px 0">
          <Typography variant="h6">
            Sign in with email
          </Typography>
        </Box>

        <Box
            display={error ? 'flex' : 'none'}
            justify="center"
            background={COLORS.errorLightest}
            padding="25px"
            margin="0 0 25px 0"
        >
          <Typography variant="subtitle1">{error?.message}</Typography>
        </Box>

        <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
          <Box justify="center" direction="column" gap="20px">
            <Controller
              name="email"
              control={control}
              defaultValue=""
              render={({ field: { onChange, onBlur, value } }) => (
                <InputV2
                  onChange={onChange}
                  value={value}
                  placeholder={'username@example.com'}
                  isError={Boolean(errors.email)}
                  helperText={errors?.email?.message}
                  onBlur={(e) => {
                    trimHandler(e.target.value, onBlur, onChange)
                  }}
                  label="Email"
                />
              )}
            />
            <Controller
              name="password"
              control={control}
              defaultValue=""
              render={({ field: { onChange, onBlur, value } }) => (
                <InputV2
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  value={value}
                  label="Password"
                  onChange={onChange}
                  isError={Boolean(errors.password)}
                  onBlur={(e) => {
                    trimHandler(e.target.value, onBlur, onChange)
                  }}
                  helperText={ errors?.password?.message }
                  rightAdornment={
                    <Icon
                      icon={showPassword ? ICONS_NAME.eyeOff : ICONS_NAME.eyeOn}
                      cursor="pointer"
                      onClick={setShowPassword}
                    />
                  }
                />
              )}
            />

          <Box margin="0 0 30px 0">
            <ButtonV2
                type="submit"
                width="100%"
                size="big">
              Sing in
            </ButtonV2>
          </Box>

          <Link to={routes.forgotPassword}>
            Forgot password?
          </Link>
          </Box>
        </form>
      </AuthWrapper>
    </>
  );
};

export default Auth;
